import { render } from "./TransactionAdministration.vue?vue&type=template&id=8e684c9e&ts=true"
import script from "./TransactionAdministration.vue?vue&type=script&lang=ts"
export * from "./TransactionAdministration.vue?vue&type=script&lang=ts"

import "./TransactionAdministration.vue?vue&type=style&index=0&id=8e684c9e&lang=css"

import exportComponent from "/Users/jonas/Developer/Fliegen/KantineV2/webapp/shop-webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__